//Services
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';

import { handleInitialLoad, pullDataWithLoading } from '../services/http';
import { socket_disconnect, socket_reconnect } from '../services/socket';
import {
	disconnect_from_device_android,
	init_discover_devices_android,
	stop_bluetooth_search_android,
	disableAccessPoint_android,
	disableBluetooth_android,
} from '../services/native_container_requests_android';
import {
	disconnect_from_device_ios,
	init_discover_devices_ios,
	stop_bluetooth_search_ios,
	disableAccessPoint_ios,
	disableBluetooth_ios,
	should_go_to,
} from '../services/native_container_requests_ios';
//Spa methods
import { push, replace, location } from 'svelte-spa-router';
//Helpers
import { objectKeysToLowerCase, wait } from '../helpers/utilities';
import { clear_cloud_disabled, get_cloud_disabled } from '../helpers/cloud_disabled_helpers';
import { clear_verified_local_ips } from '../helpers/local_ip_probe_helpers';
import {
	translate_single_device_container_data,
	translateSingleDeviceDataFromNativeIAmFeelingLucky,
	closeInclusionModal,
	routeToDevice,
} from '../helpers/inclusion_helpers';
import { go_to_navigation } from '../helpers/go_to_helper';
import { getDeviceType } from 'src/helpers/add_delete_helpers';
//Configs
import { devices_config } from '@devices/index';
//Stores
import { user_data, home_data } from 'src/stores/account/user';
import { devices_status } from 'src/stores/device-runtime/status';
import { stackedMobileEvents } from 'src/stores/features/ai-model';
import { alexaInstalled } from 'src/stores/integrations/alexa';
import { devices } from 'src/stores/lists/devices';
import { isShowedDeviceBluetoothScan } from 'src/stores/session/alerts-onboarding';
import {
	os,
	wearables_connected,
	wifi_ssid,
	network,
	wifi_ssids,
	bluetooth,
	location_state,
} from 'src/stores/session/native-bridge';
import { app_icon } from 'src/stores/session/preferences';

import {
	inclusionState,
	inclusionStarted,
	discoveredBleDevices,
	includingDeviceData,
	// timeoutFailTimer,
	// clearTimeoutFailTimer,
	advertisingBleDevices,
	discoveredWiFiDevices,
	nonShellyNetworks,
	includeDeviceModal,
} from 'src/stores/features/inclusion';

import { ongoingDiscovery, allDiscovered } from 'src/stores/features/discovered';
import {
	addDeviceModal,
	authenticateGen2DeviceModal,
	cloud_disabled_devices,
	pending_connection_devices,
} from 'src/stores/device-runtime/firmware-ui';
//Design system components
import { toast } from '@Shelly/shelly-design-system';

import { bleControlHandler, error_keys, status_keys } from 'src/helpers/ble_control_helpers';
import { brpcResponse } from 'src/stores/features/ble/brpc';
import { getLandingHref } from 'src/helpers/main_menu';
import { afterLoginParams } from 'src/stores/session/after-login-route';
import { getXT1APDiscovered, getShellyXInfoByJTI } from 'src/helpers/xt1_helpers/template_helpers';

import type { DeviceIncludeAssociateData } from 'src/types/NativeInclusionData';
import type { Device } from 'src/types/Device';
import { loadingData } from 'src/stores/ui/loading-data';
import { modalStore } from 'src/stores/ui/modal_states';
import { ValidateEmailPromptModalConfig } from 'src/configs/modals/ValidateEmailPromptModalConfig';
import { BluetoothScanModalConfig } from 'src/configs/modals/BluetoothScanModalConfig';
import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
import type { BiometryNativeResponseModel } from 'src/types/biometry/BiometryNativeResponseModel';
import { biometry_info_store, biometry_store } from 'src/stores/features/biometry';
import { isBluRotaryKnob, macToID } from 'src/helpers/interface_helpers';

const _format = get(format);

let seenNoConnection = false;
export const mobileEvents: {
	info: (info: string) => Promise<void>;
	network_status: (network_status: any) => Promise<void>;
	discovered_devices: (new_devices: any) => void;
	pause_app: () => void;
	resume_app: () => void;
	get_wifi_success: (ssids: any) => void;
	include_devices_success: (success: any, failed: any) => void;
	include_devices_stop: (prop: any) => void;
	go_to_room: (id: any) => void;
	go_to: (str: any) => void;
	wearables_connected: () => void;
	go_to_alexa: (params: any) => void;
	go_to_third_party_login: (params: any) => void;
	report_js_eval: (str: any) => { isok: boolean; request: any };
	go_to_device: (id: any) => void;
	discovering_devices: (id: any) => void;
	i_am_feeling_lucky: (device_data: any) => { isok: boolean };
	including_device: (device_data: any) => Promise<void | { isok: boolean }>;
	controlling_device: (device_data: any) => Promise<void | { isok: boolean }>;
	scan_qr_code_success?: (isok: any, content: any) => void;
	rpc_over_ble_result: (isok: any, content: any) => void;
	alexa_installed: (is_installed: string) => void;
	biometry: (data) => void;
} = {
	network_status: async (network_status) => {
		// console.log('MOBILE NETWORK STATUS', network_status);
		network.set(network_status);
		if (network_status !== 'offline' && seenNoConnection) {
			seenNoConnection = false;
		}
		if (network_status !== 'wifi') {
			Object.keys(get(cloud_disabled_devices)).forEach((id) => {
				clear_cloud_disabled(id);
			});
		}

		// clear all discovered when network is changed
		allDiscovered.set({});
		clear_verified_local_ips();
		// try to discover devices again
		if (network_status === 'wifi' && get(home_data)?.globalLocalControl?.useLocal) {
			if (get(os) === 'IOS') {
				init_discover_devices_ios();
			} else {
				init_discover_devices_android();
			}
			ongoingDiscovery.set(true);
			setTimeout(() => {
				ongoingDiscovery.set(false);
			}, 25000);
		}

		if (!get(inclusionStarted)) {
			if (network_status !== 'offline' && get(user_data).email) {
				loadingData.set(false);
				// await pullDataWithLoading(); // calls => handleInitialLoad
				await handleInitialLoad();
			}
			//  else {
			// 	setTimeout(() => {
			// 		toast.open({
			// 			type: 'danger',
			// 			title: get(format)('no_connection_toast', {
			// 				default: 'No Internet Connection'
			// 			})
			// 		});
			// 	}, 2500);
			// }
		}
	},
	info: async (info) => {
		if (import.meta.env.DEV) {
			console.log('📱 MOBILE INFO', JSON.parse(info));
		}

		const info_data = JSON.parse(info);

		try {
			if (typeof info_data?.network_status !== 'undefined') {
				network.set(info_data.network_status);
			}

			if (typeof info_data?.ssid !== 'undefined') {
				wifi_ssid.set(info_data.ssid);
			}

			if (typeof info_data?.bluetooth_state !== 'undefined') {
				bluetooth.set(info_data.bluetooth_state);
			}

			if (typeof info_data?.location_state !== 'undefined') {
				location_state.set(info_data.location_state);
			}

			if (typeof info_data?.icon !== 'undefined') {
				app_icon.set(info_data.icon);
			}

			if (typeof info_data?.biometry !== 'undefined') {
				biometry_info_store.set(info_data.biometry);
			}
		} catch (error) {
			console.error('Error parsing info data', error);
		}

		if (!get(inclusionStarted) && info_data.network_status === 'offline') {
			//This notification maybe is better to be only inside network_status
			setTimeout(() => {
				if (!seenNoConnection) {
					seenNoConnection = true;
					toast.open({
						type: 'danger',
						title: get(format)('no_connection_toast', {
							default: 'No Internet Connection',
						}),
					});
				}
			}, 2500);
		}
	},
	discovered_devices: (new_devices) => {
		const parsed_data = JSON.parse(new_devices);
		const _cloud_disabled_devices = get(cloud_disabled_devices);
		if (import.meta.env.DEV) {
			console.log('📱 MOBILE DISCOVERED DEVICES', parsed_data);
		}

		if (get(network) === 'wifi') {
			allDiscovered.set({});

			// if a device is cloud disabled and is no longer discovered in the local network,
			// mark it as offline
			let _allDiscovered = objectKeysToLowerCase(parsed_data);
			if (_cloud_disabled_devices) {
				for (const device in _cloud_disabled_devices) {
					if (!_allDiscovered.hasOwnProperty(device)) {
						const _status = devices_status.getByRealId(device);
						if (_status) {
							_status.online = false;
							devices_status.update_device_status({ device, msg: _status });
						}
					}
				}
			}

			allDiscovered.update(() => {
				return _allDiscovered;
			});

			get_cloud_disabled();
			// clear ongoingDiscovery on discovered list
			if (get(ongoingDiscovery)) {
				ongoingDiscovery.set(false);
			}
		} else {
			allDiscovered.set({});
			clear_verified_local_ips();
		}

		console.log('💾 result form scan in store', get(allDiscovered));
	},
	pause_app: () => {
		// console.log('MOBILE PAUSE APP');
		// Disconnect the cloud web sockets while on background
		socket_disconnect();
	},
	resume_app: async () => {
		console.log('📱 RESUME APP');
		modalStore.setModals([ValidateEmailPromptModalConfig, BluetoothScanModalConfig]);
		isShowedDeviceBluetoothScan.set(false);
		if (get(os) === 'IOS') {
			should_go_to();
		}

		// check if user is trying to log in as installer. Prevents double initialization of the app
		if (get(user_data).email && !get(location).includes('fast-login')) {
			await handleInitialLoad();
		}
	},
	get_wifi_success: (ssids) => {
		console.log('GET WIFI SUCCESS', ssids);
		wifi_ssids.set(ssids);
	},
	include_devices_success: function (success, failed) {
		// console.log('INCLUDE DEVICES SUCCESS');
		// console.log('success:', success, 'failed:', failed);
		if (get(inclusionStarted)) {
			if (success === 1) {
				setTimeout(() => {
					// console.warn('TIME OUT OF 5 SEC');
					//@ToDo: Refactor: Check if WS reconnect is still needed
					socket_reconnect();

					push('/discovered');
					toast.open({
						type: 'success',
						title: `Device was included in your WiFi network.`,
					});
				}, 5000);

				return;
			} else if (success === 0) {
				//@ToDo: Refactor: Check if WS reconnect is still needed
				socket_reconnect();

				toast.open({
					type: 'danger',
					title: 'Failed to include any device to your wifi network.',
				});
			}
		}
	},
	include_devices_stop: function (prop) {
		console.log('INCLUDE DEVICES STOP', prop);
		// clearTimeoutFailTimer();
		// closeInclusionModal();
		inclusionState.set({
			id: 99,
			raw_value: 'bluetoothInclusionStop',
			value: get(format)('bluetooth_inclusion_stop'),
			type: 'error',
		});
		// toast.open({ type: 'danger', title: `Failed to include device.` });
	},
	go_to_room: (id) => {
		push(`/room/${id}`);
	},
	go_to: (str) => {
		console.log('go_to', str);
		go_to_navigation(str);
	},
	wearables_connected: (count = 0) => {
		wearables_connected.set(count);
	},
	go_to_alexa: (params) => {
		// used for by Android only
		if (!get(user_data).email) {
			afterLoginParams.set({
				route: '/settings/app-to-app-alexa',
				location: '/settings/app-to-app-alexa',
				querystring: params,
				params: {},
			});
		} else {
			replace(getLandingHref());
			push('/settings/app-to-app-alexa?' + params);
		}
	},
	go_to_third_party_login: (params) => {
		const integrationsRoute = '/third_party_integrations_login?' + params;
		// if (get(user_data).email === '') {
		// 	replace('/login' + integrationsRoute)
		// } else {
		replace(integrationsRoute);
		// }
	},
	report_js_eval: (str) => {
		// console.log('test ', str);
		return { isok: true, request: str };
	},
	go_to_device: (id) => {
		replace(`/dashboard`);
		push(`/device/${id}`);
	},
	alexa_installed: (is_installed) => {
		console.log('is_installed', JSON.parse(is_installed));
		alexaInstalled.set(JSON.parse(is_installed));
	},
	i_am_feeling_lucky: undefined,
	including_device: undefined,
	controlling_device: undefined,
	discovering_devices: undefined,
	scan_qr_code_success: undefined,
	rpc_over_ble_result: undefined,
	biometry: undefined,
};

mobileEvents.i_am_feeling_lucky = function (device_data) {
	const parsed_data = JSON.parse(device_data);
	// console.log('mobile.i_am_feeling_lucky', parsed_data);

	if (Object.keys(parsed_data)[0] === 'status') {
		// inclusion is progressing getting status updates to show progress (viable for iOS)
	} else if (Object.keys(parsed_data)[0] === 'errors') {
		toast.open({
			type: 'danger',
			title: _format(error_keys['errors']),
		});
	} else if (
		Object.keys(parsed_data).length == 1 &&
		typeof Object.values(parsed_data)[0] === 'object' &&
		Object.values(parsed_data)[0] !== null &&
		Object.values(parsed_data)[0] !== 'string'
	) {
		// inclusion is all done getting device id as key of the data object (viable for both iOS and Android)
		let single_device_data: any = Object.values(parsed_data)[0];
		single_device_data.id = Object.keys(parsed_data)[0].toLowerCase();

		if (!translateSingleDeviceDataFromNativeIAmFeelingLucky(single_device_data)) {
			// console.log('trying to add lucky');
			toast.open({
				type: 'danger',
				title: 'Trying to add unknown device type. Please try again to confirm. If this error persists contact support to verify the device authenticity.',
			});
			return { isok: false };
		}

		if (typeof get(devices)[single_device_data.id] !== 'undefined') {
			// device is already owned
			push(`/home/room/${get(devices)[single_device_data.id].room_id}/devices`);

			setSidePanelState({
				type: 'device',
				id: single_device_data.id,
				open: true,
			});
		} else {
			// associate the new device to the account
			addDeviceModal.set(true);
		}
		return { isok: true };

		// if (isOwned(single_device_data.id)) {
		// 	toast.open({
		// 		type:'danger',
		// 		title:_format('cloud_connect_owned_err_toast', {
		// 			default:
		// 				'Failed to associate device with your account beacuse is already associated with another account.'
		// 		}),
		// 		duration:5000
		// 	});
		// 	return { isok: true };
		// }

		// push('/home/devices/-1');
	} else if (Object.keys(parsed_data).length > 1) {
		// inclusion is all done for multiple devices. Getting device ids as keys (viable for both iOS and Android)
		// ToDo handle adding multiple devices... for now just go to the "descovered devices" page
		replace('/discovered');
		return { isok: true };
	}
	return { isok: true };
};

// figure out how to reset the stores after the inclusion process is finished
mobileEvents.including_device = async function (device_data): Promise<void | { isok: boolean }> {
	const _includingDeviceData: DeviceIncludeAssociateData = get(includingDeviceData); // this is a inclusion device store, used to keep currently including device data
	const timeStamp = new Date().getTime();

	const parsed_data: {
		settings?;
		status?;
		discovered_ble_devices?;
		error?;
		errors?;
		device?;
		progress?;
		list?;
		devices?;
	} = JSON.parse(device_data);

	// const preprocessing = typeof parsed_data?.device?.settings === 'undefined';//if this statement is true device isn't yet processed from containers
	const isDevice =
		typeof parsed_data?.device !== 'undefined' && typeof parsed_data?.device !== 'string'; //sometimes we get device as string which is the same as the above variable. ToDo need to merge these variables
	const device = isDevice
		? Object.assign({}, parsed_data?.device)
		: Object.assign({}, _includingDeviceData); //if is device we will update working variable with correct data, else we will use cached data
	// const isGen1 = device?.gen == 1 || device?.info?.gen == 1 || device?.info?.longid == 1 || device?.longid == 1;
	// const isGen2 = device?.gen == 2 || device?.info?.gen == 2;
	// const isGBLE = device?.gen === 'GBLE' || device?.info?.gen === 'GBLE';
	// const isEncrypted = isGen2 ? true : isGen1 ? true : !preprocessing ? device?.settings?.encrypted : false;//this variable needs some other name. The idea is to know when inclusion process is finished

	// console.log(
	// 	'%cCached device from mobile_including_device',
	// 	'color: red',
	// 	device,
	// );
	//ToDo check all gens inclusion

	if (get(includeDeviceModal).show) {
		stackedMobileEvents.update((prevEvents) => {
			const event = parsed_data.status || parsed_data.error;
			let newPrevEvents = [];
			if (prevEvents.includes(event)) {
				newPrevEvents = prevEvents.filter((e) => e !== event);
			} else {
				newPrevEvents = prevEvents;
			}
			newPrevEvents.push(event);
			return newPrevEvents;
		});
	}

	if (parsed_data?.status) {
		if (
			typeof _includingDeviceData?.id !== 'undefined' &&
			parsed_data.status === 'deviceDiscovered'
		) {
			return { isok: true }; //prevent overriding of status if deviceAdvDataChanged event comes for other device during inclusion process
		}

		if (
			parsed_data.status !== 'deviceAdvDataChanged' ||
			(parsed_data.status !== 'deviceDiscovered' &&
				(typeof _includingDeviceData?.id !== 'undefined' ||
					typeof _includingDeviceData?.info?.id !== 'undefined'))
		) {
			includingDeviceData.updateData({
				status: {
					[timeStamp]: parsed_data.status,
				},
			});
		}

		if (parsed_data.status === 'deviceAdvDataChanged') {
			advertisingBleDevices.addClicked(parsed_data.device);
			if (device.model === 'SMSN-0031ZL' || device?.id === parsed_data.device) {
				//preventing false inclusion aka w/o pressing button
				includingDeviceData.updateData({ buttonPressed: true });
			}
			return { isok: true };
		}

		inclusionState.set({
			id: Object.keys(status_keys).indexOf(parsed_data.status),
			value: _format(status_keys[parsed_data.status]),
			raw_value: status_keys[parsed_data.status],
			type: 'status',
		});

		if (parsed_data.status === 'connectedToDevice') {
		} else if (parsed_data.status === 'deviceDiscovered') {
			let dConfig;
			let dTypeSplit;

			//Getting device type
			if (isDevice) {
				dTypeSplit = getDeviceType(device);
			} else {
				dTypeSplit = undefined;
			}

			if (/SBRK-002C|ShellyBLURotaryKnob/i.test(device.name || '')) {
				device.model = 'SBRK-002C';
				device.type = 'SBRK-002C';
			}

			if (/SBSN-001B|ShellyBLULiquidLevel/i.test(device.name || '')) {
				device.model = 'SBSN-001B';
				device.type = 'SBSN-001B';
			}

			//Getting device config
			if (device.model || dTypeSplit) {
				//device model is for gble devices/dType is for gen 2 mostly
				Object.entries(devices_config).forEach(([k, v]) => {
					if (typeof device.model !== 'undefined') {
						if (device.model === k) {
							dConfig = v;
							dConfig.type = k;
						}
					} else {
						if (v?.name?.toLowerCase() === dTypeSplit[0]?.toLowerCase()) {
							dConfig = v;
							dConfig.type = k;
						}
					}
				});
			}

			//Getting device name, model and type
			if (dConfig) {
				device.jumbledID = device.id;
				// jumbledID handles jumbled Mac returned via Bluetooth scan that is returned by Gen.2 devices with firmware versions between 0.14.** to 1.0.3
				device.jumbledID = device.jumbledID
					.split(/(?=(?:..)*$)/)
					.reverse()
					.toString()
					.replace(/,/g, '');
				device.type = dConfig.type;
				device.model = device.type;
				if (isBluRotaryKnob(device.type) && device.id) {
					device.gen = 'GBLE';
					const normalizedMac = String(device.id).replace(/:/g, '');
					if (/^[0-9a-f]{12}$/i.test(normalizedMac)) {
						device.id = macToID(normalizedMac);
					}
				}

				if (device.jti) {
					const config = await getShellyXInfoByJTI(device.jti, device.model);
					if (config) {
						discoveredBleDevices.update((data) => {
							data[device.id] = {
								...device,
								name: config?.name || dConfig.friendly_name,
								service_type: config?.service_type,
								image: config?.image || device.image,
							};
							return data;
						});
					}
				} else {
					device.name = dConfig.friendly_name;
					if (device.model !== 'SBTR-001AEU') {
						discoveredBleDevices.update((data) => {
							data[device.id] = device;
							return data;
						});
					}
				}

				console.log('%c 🦩 device', 'color: pink;', device);
			}
		} else if (parsed_data.status === 'wifiDevicesDiscovered') {
			const wiFiNetworks = parsed_data.devices.filter((ssid) => {
				const lastDashIndex = ssid.lastIndexOf('-');
				const name = ssid.substring(0, lastDashIndex);

				const matchedDevice =
					Object.values(devices_config).find(
						(device) => device.name.toLowerCase() === name.toLowerCase(),
					) || getXT1APDiscovered(ssid);

				return !matchedDevice;
			});

			nonShellyNetworks.set(
				parsed_data.devices.filter((ssid) => {
					const lastDashIndex = ssid.lastIndexOf('-');
					const name = ssid.substring(0, lastDashIndex);

					const matchedDevice =
						Object.values(devices_config).find(
							(device) => device.name.toLowerCase() === name.toLowerCase(),
						) || getXT1APDiscovered(ssid);
					if (!matchedDevice) {
						return ssid;
					}
				}),
			);
			console.log(get(nonShellyNetworks));

			wifi_ssids.set(wiFiNetworks);
			parsed_data.devices.forEach((shellySSID: string) => {
				const lastDashIndex = shellySSID.lastIndexOf('-');
				const name = shellySSID.substring(0, lastDashIndex);
				const mac = shellySSID.substring(lastDashIndex + 1);
				const xt1Discovered = getXT1APDiscovered(shellySSID);
				if (xt1Discovered) {
					const deviceFromAPSSID = {
						...xt1Discovered,
						id: mac.toLowerCase(),
						shellySSID,
					};
					console.log('%c 🦩 XT1 device', 'color: pink;', deviceFromAPSSID);

					// discoveredWiFiDevices.update((data) => {
					// 	data.push(deviceFromAPSSID);
					// 	return data;
					// });
				} else {
					let dConfig = undefined;
					Object.entries(devices_config).forEach(([i, e]) => {
						if (device.model === i) {
							dConfig = e;
							dConfig.type = i;
						}
						if (e.name.toLowerCase() === name.toLowerCase()) {
							dConfig = e;
							dConfig.type = i;
						}
					});

					if (dConfig) {
						const deviceFromAPSSID = {
							name: dConfig.friendly_name,
							type: dConfig?.type,
							friendly_name: dConfig?.friendly_name,
							id: mac.toLowerCase(),
							shellySSID,
						};
						console.log('%c 🦩 device', 'color: pink;', deviceFromAPSSID);

						discoveredWiFiDevices.update((data) => {
							data.push(deviceFromAPSSID);
							return data;
						});
					}
				}
			});
		} else if (parsed_data.status === 'requestDigestPasswordFromUser') {
			//waiting for IOS android is ready
			authenticateGen2DeviceModal.set(device.mac || device.id);
			//device mac-android, id ios
		} else if (parsed_data.status === 'digestPasswordSet') {
			authenticateGen2DeviceModal.set(undefined);
		} else if (parsed_data.status === 'connectingAborted') {
			// stopBluetoothScanner();
			// closeInclusionModal();
		} else if (parsed_data.status === 'disconnectedFromDevice') {
			// stopBluetoothScanner();
			// closeInclusionModal();
		} else if (parsed_data.status === 'accessPointDisabled') {
			includingDeviceData.updateData({ disableWiFiAp: false });
			const _device = get(includingDeviceData);

			if (!_device.disableBluetooth) {
				if (get(os) === 'IOS') {
					disconnect_from_device_ios();
					stop_bluetooth_search_ios();
				} else {
					disconnect_from_device_android();
					stop_bluetooth_search_android();
				}

				inclusionStarted.set(false);
				if (typeof get(devices)[_device.id] !== 'undefined') {
					// device is already associated

					pending_connection_devices.add(_device.id);

					//@ToDo: Refactor: Check if WS reconnect is still needed
					socket_reconnect();
					setTimeout(() => {
						closeInclusionModal();
						routeToDevice(_device);
					}, 2000);
					return { isok: true };
				} else {
					setTimeout(() => {
						closeInclusionModal();
						addDeviceModal.set(true);
					}, 2000);
				}
			} else {
				if (get(os) === 'IOS') {
					disableBluetooth_ios();
				} else {
					disableBluetooth_android();
				}
			}
		} else if (parsed_data.status === 'bluetoothDisabled') {
			includingDeviceData.updateData({ disableBluetooth: false });
			const _device = get(includingDeviceData);

			await wait(500);
			if (get(os) === 'IOS') {
				disconnect_from_device_ios();
				stop_bluetooth_search_ios();
			} else {
				disconnect_from_device_android();
				stop_bluetooth_search_android();
			}

			inclusionStarted.set(false);
			if (typeof get(devices)[_device.id] !== 'undefined') {
				// device is already associated
				pending_connection_devices.add(_device.id);
				socket_reconnect();
				setTimeout(() => {
					closeInclusionModal();
					routeToDevice(_device);
				}, 2000);
				return { isok: true };
			} else {
				setTimeout(() => {
					closeInclusionModal();
					addDeviceModal.set(true);
				}, 2000);
			}
		} else if (parsed_data.status === 'deviceProcessed') {
			if (import.meta.env.DEV) {
				console.log('%c deviceProcessed', 'font-size:24px; color:red;', device);
			}

			includingDeviceData.updateData({ ...device });

			const translatedDevice: Device = await translate_single_device_container_data(device);

			// clearTimeoutFailTimer();

			if (typeof translatedDevice == 'undefined') {
				toast.open({
					type: 'danger',
					title: 'Trying to add unknown device type. Please try again to confirm. If this error persists contact support to verify the device authenticity.',
				});
				return { isok: false };
			}

			const _device: DeviceIncludeAssociateData = get(includingDeviceData);
			//_device disableWiFiAp and disableBluetooth are relevant only for gen2 devices for now. Setting this props from include wizard component.
			if (get(os) === 'IOS') {
				if (_device?.disableWiFiAp) {
					return disableAccessPoint_ios();
				}
				if (_device?.disableBluetooth) {
					return disableBluetooth_ios();
				}
				if (!_device?.disableWiFiAp && !_device?.disableBluetooth) {
					disconnect_from_device_ios();
					stop_bluetooth_search_ios();
				}
			} else {
				if (_device?.disableWiFiAp) {
					disableAccessPoint_android();
					return { isok: true };
				}
				if (_device?.disableBluetooth) {
					disableBluetooth_android();
					return { isok: true };
				}
				if (!_device?.disableWiFiAp && !_device?.disableBluetooth) {
					disconnect_from_device_android();
					stop_bluetooth_search_android();
				}
			}

			// stopBluetoothScanner();
			inclusionStarted.set(false);
			if (!_device?.disableWiFiAp && !_device?.disableBluetooth) {
				if (typeof get(devices)[translatedDevice?.id] !== 'undefined') {
					// bluetooth inclusion
					pending_connection_devices.add(translatedDevice.id);
					setTimeout(() => {
						closeInclusionModal();
						socket_reconnect();
						routeToDevice(translatedDevice);
					}, 2000);
					return { isok: true };
				} else {
					// Both gen 1 and 2
					setTimeout(() => {
						closeInclusionModal();
						addDeviceModal.set(true);
					}, 2000);
				}
			}
		}
	} else if (parsed_data?.error) {
		console.error('parsed_data.error', parsed_data.error);
		// clearTimeoutFailTimer();

		inclusionState.set({
			id: Object.keys(error_keys).indexOf(parsed_data.error),
			raw_value: parsed_data.error,
			value: _format(error_keys[parsed_data.error]),
			type: 'error',
		});

		if (parsed_data?.error === 'unpairDeviceRequired') {
			toast.open({
				type: 'danger',
				title: _format(error_keys[parsed_data.error], {
					default: 'Unpair device required',
				}),
				text: _format(error_keys[parsed_data.error], {
					default: "Please remove the device from the phone's Bluetooth paired devices list.",
				}),
			});
			closeInclusionModal();
		} else if (parsed_data?.error === 'bluetoothDisabled') {
			if (import.meta.env.DEV) {
				toast.open({
					type: 'danger',
					title: _format(error_keys[parsed_data.error], {
						default:
							'Bluetooth access is disabled for this application. Please enable it from your IOS settings.',
					}),
				});
			}
			closeInclusionModal();
		} else if (parsed_data?.error === 'phoneBluetoothDisabled') {
			if (import.meta.env.DEV) {
				toast.open({
					type: 'danger',
					title: _format(error_keys[parsed_data.error], {
						default:
							'Phone bluetooth is disabled. Please enable it from your IOS settings or control center.',
					}),
				});
			}
			closeInclusionModal();
		} else if (parsed_data?.error === 'connectionTimeout') {
			toast.open({
				type: 'danger',
				title: _format(error_keys[parsed_data.error], {
					default: 'Device connection timed out.',
				}),
			});
		} else if (parsed_data?.error === 'cantSetPassword') {
			toast.open({
				type: 'danger',
				title: _format(error_keys[parsed_data.error], {
					default: `Can't set password.`,
				}),
			});
		} else if (parsed_data?.error === 'pairingDenied') {
			toast.open({
				type: 'danger',
				title: _format(error_keys[parsed_data.error], {
					default: `Device pairing denied.`,
				}),
			});
		} else if (parsed_data?.error === 'userDenied') {
			toast.open({
				type: 'danger',
				title: _format(error_keys[parsed_data.error], {
					default: `Operation cancelled by user.`,
				}),
			});
			closeInclusionModal();
		} else {
			// toast.open({
			// 	type: 'danger',
			// 	title: _format(error_keys[parsed_data.error])
			// });
		}

		// stopBluetoothScanner();
	}
	return { isok: true };
};

mobileEvents.controlling_device = async function (nativeLayerData) {
	let payload = nativeLayerData;
	let parsed;
	try {
		parsed = JSON.parse(payload);
	} catch {
		/**
		 * Some native payloads (e.g. `deviceOtaAvailable`) embed unescaped
		 * control characters (U+0000–U+001F) inside the firmware version
		 * string, which is invalid JSON and breaks `JSON.parse`. Strip the
		 * stray control characters and retry so the status is still handled
		 * instead of throwing an uncaught rejection and dropping the event.
		 */
		payload =
			typeof nativeLayerData === 'string'
				? nativeLayerData.replace(/[\u0000-\u001F]+/g, '')
				: nativeLayerData;
		try {
			parsed = JSON.parse(payload);
		} catch (err) {
			console.error('controlling_device: unparseable native payload', err, nativeLayerData);
			return;
		}
	}
	if (parsed.status === 'brpc') {
		brpcResponse.set({ frame: parsed.frame, timestamp: Date.now() });
		return;
	}
	bleControlHandler(payload);
};

mobileEvents.scan_qr_code_success = async function (isok: any, content: any) {
	// if (content.length > 0) {
	// 	const parsedData: void | {
	// 		productId: number;
	// 		applicationVersion: string;
	// 		dsk: string;
	// 		genericDeviceClass: string;
	// 		installerIconType: string;
	// 		manufacturerId: string;
	// 		productType: string;
	// 		requestedSecurityClasses: number[];
	// 		specificDeviceClass: number[];
	// 		version: string;
	// 		qr: string;
	// 	} = parseQRCodeString(content);
	// 	delete parsedData.applicationVersion;
	// 	delete parsedData.genericDeviceClass;
	// 	delete parsedData.installerIconType;
	// 	delete parsedData.manufacturerId;
	// 	delete parsedData.productType;
	// 	delete parsedData.specificDeviceClass;
	// 	delete parsedData.version;//removing unneeded keys
	// 	includingDeviceData.updateData({ zWaveParsedData: parsedData });
	// } else {
	// 	includingDeviceData.updateData({ zWaveParsedData: { error: "canceled" } });
	// }
};

mobileEvents.rpc_over_ble_result = async function (isok: any, content: any) {
	console.log('data from rpc_over_ble_result', content);
};

mobileEvents.biometry = function (data) {
	const parsedData = JSON.parse(data) as BiometryNativeResponseModel;
	biometry_store.set(parsedData?.biometry);
};
